<template>
  <div class="dashboard__card">
    <CardLoading v-if="loaders.dashboardData"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.dashboardData }">
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Fuel Utilization</div>
        <span class="dashboard__card-title-addendum">{{ dateRangeText }}</span>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--fuel-utilization"><i class="fa fa-tasks"></i></div>
      </div>
      <div class="row dashboard__card-body dashboard__card-body--bordered">
        <div class="dashboard__grid dash-fuel-utilization__content-container">
          <div class="col-sm-12 dashboard__card-body-col dashboard__card-body-col--shaded dashboard__card-body-col--fuel-utilization">
            <div class="row">
              <div class="dash-fuel-utilization__work-orders" v-if="workOrders.length">
                <div class="dash-fuel-utilization__recent-work-orders-header">Recent In Progress</div>
                <div class="dash-fuel-utilization__work-order" v-for="(workOrder, index) in workOrders" :key="workOrder.id">
                  <div class="dash-fuel-utilization__work-order-name">{{ workOrder.title }}</div>
                  <div class="dash-fuel-utilization__work-order-status" :class="workOrderStatusClass(workOrder.portalStatus)">{{ workOrder.portalStatus }}</div>
                </div>
              </div>
              <div class="alert alert-warning" v-else>
                <div class="dashboard__no-data">No recent work order activity</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link">
          <router-link to="/fuel-utilization" class="dashboard__card-link-text">View All</router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import lodash from 'lodash';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import Datepicker from 'vuejs-datepicker';
  import CardLoading from './CardLoading.vue';

  export default {
    name: 'FuelUtilizationCard',
    components: {
      CardLoading,
      Datepicker,
    },
    data() {
      return {
        recentInProgressDateFrom: moment().subtract('3', 'months').format('YYYY-MM-DD'),
        recentInProgressDateTo: moment().format('YYYY-MM-DD'),
        limit: 9,
        includedStatuses: ['Member Review', 'In Progress', 'Complete'],
      };
    },
    async mounted() {
      await this.$store.dispatch('fuelUtilization/getDateList');
      this.recentInProgressDateTo = moment(this.dateList[0]).toDate();
      this.recentInProgressDateFrom = this.dateList.length > 3 ? moment(this.dateList[2]).toDate() : moment(this.dateList.length - 1).toDate();
      this.getFuelUtilization();
    },
    computed: {
      ...mapGetters('fuelUtilization', ['loaders', 'dateList', 'dashboardData']),
      dateRangeText() {
        return `${moment(this.recentInProgressDateFrom).format('MMM YYYY')} - ${moment(this.recentInProgressDateTo).format('MMM YYYY')}`;
      },
      fuelUtilDisabledRangeFrom() {
        return {
          to: moment(this.dateList[this.dateList.length - 1]).toDate(),
          from: this.recentInProgressDateTo ? moment(this.recentInProgressDateTo).toDate() : moment(this.dateList[0]).endOf('month').toDate(),
        }
      },
      fuelUtilDisabledRangeTo() {
        return {
          to: this.recentInProgressDateFrom ? moment(this.recentInProgressDateFrom).toDate() : moment(this.dateList[this.dateList.length - 1]).toDate(),
          from: this.dateList.length > 0 ? moment(this.dateList[0]).endOf('month').toDate() : moment().endOf('month').toDate(),
        };
      },
      fuelUtilDisabledRange() {
        return {
          from: new Date('2014-04-01'),
          to: new Date(this.recentInProgressDateTo),
        };
      },

      workOrders() {
        const workOrders = lodash.chain(this.dashboardData.workOrders)
          // we only want to include certain statuses so we remove all other work orders
          .filter(workOrder => (this.includedStatuses).includes(workOrder.portalStatus))
          // take the number of most recent work orders defined by limit
          .take(this.limit)
          // get the value from the chain
          .value();

        const workOrderObject = {};
        lodash.map(this.includedStatuses, (status) => {
          workOrderObject[status] = lodash.filter(workOrders, workOrder => workOrder.portalStatus === status);
        });

        return lodash.chain(workOrderObject)
          // convert object to an array of arrays of work orders
          .values()
          // flatten to one array
          .flatten()
          // get the value from the chain
          .value();
      }
    },

    methods: {
      /**
       * Loads Fuel Utilization metrics for the past three months
       */
      getRecentInProgress() {
        this.$store.dispatch('fuelUtilization/getDashboardWorkOrders', {
          dateFrom: moment(this.recentInProgressDateFrom).format('YYYY-MM-DD'),
          dateTo: moment(this.recentInProgressDateTo).endOf('month').format('YYYY-MM-DD'),
        });
      },
      workOrderStatusClass(status) {
        return this.includedStatuses.includes(status) ?
          `dash-fuel-utilization__work-order-status--${lodash.kebabCase(status)}` : '';
      },
    },
  };
</script>
